import { render, staticRenderFns } from "./DeliveryItemsList.vue?vue&type=template&id=5aced3f2"
import script from "./DeliveryItemsList.vue?vue&type=script&lang=js"
export * from "./DeliveryItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports